import { Injectable } from '@angular/core';
import { Action, createSelector, State, StateContext, StateToken } from '@ngxs/store';
import { AddOriginUrl } from '@stores/event/event-origin.actions';

export interface EventOriginStateModel {
  segments: string[];
  queryParams: Record<string, string> | undefined;
  fragment: string | undefined;
}
const eventOriginToken = new StateToken<EventOriginStateModel>('eventOrigin');

@State<EventOriginStateModel>({
  name: eventOriginToken,
  defaults: {
    segments: [],
    queryParams: {},
    fragment: '',
  },
})
@Injectable()
export class EventOriginState {
  static originSegments(): (state: EventOriginStateModel) => string[] {
    return createSelector([EventOriginState], (state: EventOriginStateModel) => state.segments);
  }
  static originQueryparams(): (state: EventOriginStateModel) => Record<string, string> | undefined {
    return createSelector([EventOriginState], (state: EventOriginStateModel) => state.queryParams);
  }

  static originFragment(): (state: EventOriginStateModel) => string | undefined {
    return createSelector([EventOriginState], (state: EventOriginStateModel) => state.fragment);
  }

  @Action(AddOriginUrl)
  AddOriginUrl(ctx: StateContext<EventOriginStateModel>, { segments, queryParams, fragment }: AddOriginUrl): void {
    const state = ctx.getState();
    ctx.setState({ ...state, segments, queryParams, fragment });
  }
}
